import "core-js/actual/array/at";
import "core-js/actual/object/has-own";
import "core-js/actual/promise/all-settled";
import "core-js/actual/promise/any";
import "core-js/actual/string/at";
import "core-js/actual/string/replace-all";
import structuredClonePolyfill from "@ungap/structured-clone";

if (typeof globalThis.structuredClone !== "function") {
  globalThis.structuredClone = structuredClonePolyfill as typeof structuredClone;
}

export default defineNuxtPlugin(() => {});
